import { render, staticRenderFns } from "./PriceFilter.vue?vue&type=template&id=5d5afd1e&scoped=true&"
import script from "./PriceFilter.vue?vue&type=script&lang=ts&"
export * from "./PriceFilter.vue?vue&type=script&lang=ts&"
import style0 from "./PriceFilter.vue?vue&type=style&index=0&id=5d5afd1e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d5afd1e",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {AtomsRangeSelector: require('/var/www/packages/theme/components/atoms/RangeSelector.vue').default,AtomsPriceRangeSlider: require('/var/www/packages/theme/components/atoms/PriceRangeSlider.vue').default,AtomsAccordion: require('/var/www/packages/theme/components/atoms/Accordion.vue').default})
